import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const spendingAlertTypeFilter = (recommendationsEnabled?: boolean): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.spending_alert_type.title'),
  type: 'in',
  options: {
    options: [
      {
        label: i18n.t('expenses_v2.list.filters.spending_alert_type.spending_policy'),
        value: 'spending_policy',
      },
      {
        label: i18n.t('expenses_v2.list.filters.spending_alert_type.mileage_rate_changed'),
        value: 'mileage_rate_changed',
      },
      {
        label: i18n.t('expenses_v2.list.filters.spending_alert_type.duplicate_expense'),
        value: 'duplicate_expense',
      },
      {
        label: i18n.t('expenses_v2.list.filters.spending_alert_type.category_conflict'),
        value: 'category_conflict',
      },
      ...(recommendationsEnabled
        ? [
            {
              label: i18n.t('expenses_v2.list.filters.spending_alert_type.policy_compliance'),
              value: 'policy_compliance',
            },
          ]
        : []),
    ],
  },
})
